import {IPassengerType, IPassengerTypeSelectorsList} from "../passengers-types.service.interface";
import {PassengerTypeSelectorBase} from "./passenger-type-selector-base";
import {PassengerTypeCodesEnum} from "../passenger-type-codes.enum";
import {IServiceFactory} from "../../service-factory.interface";

export class DogSelector extends PassengerTypeSelectorBase {
    constructor(service: IServiceFactory, passengersList: IPassengerTypeSelectorsList, count: number = 0) {
        super(service.passengerTypes.getAnimalTypes(),  service, passengersList, count);
    }

    protected _getImplicitPassengerType(): IPassengerType {
        const passengerType = this.passengerTypes.find(pt => pt.code === PassengerTypeCodesEnum.Dog);
        if(passengerType) {
            return passengerType;
        }

        throw new Error(`Didn't find passenger type code ${PassengerTypeCodesEnum.Dog}`);
    }

    get allowIncrement(): boolean {
        return this.count < 1;
    }

}